export default "__VITE_ASSET___OWBcIX5__"